import { Divider, DividerProps, styled } from '@mui/material';

export const FormDividerStyled = styled(Divider)`
  margin-bottom: 24px !important;
`;

export const FormDivider: React.FC<DividerProps> = (props) => {
  return <FormDividerStyled light {...props} />;
};
